export default __webpack_public_path__ + "static/media/tick.8d881607.svg";